import React from 'react'

class Help extends React.Component {

	render() {
		return (
			<div className="box">
				<div className="box-header with-border">
					<h3 className="box-title"><strong>Instructions on how to complete Matrix {this.props.stepCode}</strong></h3>
				</div>
				<div className="box-body">
					<div dangerouslySetInnerHTML={{ __html: this.props.content }} />
				</div>
			</div>)
	}
}

export default Help;


// WEBPACK FOOTER //
// ./src/areas/certification/comps/Help.js